module.exports = __webpack_public_path__ + "static/media/hsp_desktop.542c1673.png";